<template>
  <div class="container text-left">
    <div class="row text-center">
      <div class="col"><h3>Stats</h3></div>
    </div>
    <div class="row">
      <div class="col">Grants Saved: {{ grantStats.Application_Count }}</div>
    </div>
    <div class="row">
      <div class="col">
        Grants Applied For: {{ grantStats.Applications_Applied }}
      </div>
    </div>
    <div class="row">
      <div class="col">Grant Won: {{ grantStats.Applications_Won }}</div>
    </div>
    <div class="row">
      <div class="col">Grant Not Won: {{ grantStats.Applications_Lost }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Template",
  data() {
    return {
      grantStats: {}
    };
  },
  async mounted() {
    var view = this;
    view.$store.commit("updateLoading", false);
    try {
      await view.$getGrantApplicationStats().then(grantStats => {
        view.grantStats = grantStats;
        view.$store.commit("updateLoading", false);
      });
    } catch (error) {
      console.log(error);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    method() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
